<div class="price">
  <div
    class="price_item"
    *ngIf="params.data.FbaBBPrice"
    [ngClass]="{
      'price_item--is-yours': params.data.BBAIsYours,
      'price_item--amazon': params.data.BBIsAmazon,
      'price_item--fba': !params.data.BBIsAmazon,
      'price_item--is-below-minumum-fba': params.data.Minpr > params.data.FbaBBPrice
    }"
    [matTooltip]="
      params.data.BBAIsYours
        ? 'Buybox won'
        : params.data.Minpr > params.data.FbaBBPrice
        ? 'FBA Buybox offer Below Min'
        : ''
    "
  >
    <div class="price_amount">${{ params.data.FbaBBPrice | number}}</div>
    <div class="price_buybox-type"></div>
  </div>

  <div
    class="price_item price_item--fbm"
    [ngClass]="{
      'price_item--is-yours': params.data.BBMIsYour,
      'price_item--is-below-minumum-fbm': params.data.Minpr > params.data.FbmBBPrice
    }"
    *ngIf="params.data.FbmBBPrice"
    [matTooltip]="
      params.data.BBMIsYour
        ? 'Buybox won'
        : params.data.Minpr > params.data.FbmBBPrice
        ? 'FBM Buybox offer Below Min'
        : ''
    "
  >
    <div class="price_amount">${{ params.data.FbmBBPrice }}</div>
    <div class="price_buybox-type"></div>
  </div>

  <div class="price_item" *ngIf="!params.data.FbaBBPrice && !params.data.FbmBBPrice">
    N/A
  </div>
  <div class="price_item price_buyBox" *ngIf="params.props === 'priceyard'" (click)="buyBoxDetail($event)">
    <svg width="8.36" height="9.38">
      <use xlink:href="assets/images/sprite-icons.svg#metro-chart-pie"></use>
    </svg>
    <div class="price_amount">{{ params.data.BbPercent | number : '1.2-2' }}%</div>
    <i [ngClass]="(params.data.BbPercentageAvg > params.data.BbPercent) ? 'fas fa-arrow-down' : 'fas fa-arrow-up'"></i>
  </div>
</div>
<div class="min" *ngIf="params.props === 'planyard' || params.props === 'shipyard'">
  <span class="min_label">Min:</span>
  <ng-container *ngIf="!edit">
    <span class="min_value"
      ><b>{{
        params.data.Minpr ? (params.data.Minpr | currency) : params.data.MinPrice ? (params.data.MinPrice | currency) : ''
      }}</b></span
    >
    <span
      class="min_edit"
      *ngIf="params.props === 'planyard' || params.props === 'shipyard'"
      (click)="startEditing($event, params)"
      ><i class="fal fa-edit me-1"></i
    ></span>
  </ng-container>
</div>
